import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; 
import 'tippy.js/animations/shift-toward.css';
import 'tippy.js/themes/light.css';


window.addEventListener('DOMContentLoaded', (event) => {
   
    // Loop trough all splide sliders
    document.querySelectorAll('.splide').forEach( (el, i) => {

        // Initialize the slider
        new Splide( el, {
            type: 'fade',
            perPage: 1,
            pagination: false
        } ).mount();

    });

    // Check if mark has multiple lines, and add a classname
    document.querySelectorAll('mark').forEach( (el, i) => {

        if ( el.offsetHeight < el.parentNode.offsetHeight ) {

            el.classList.add('multiline');

        }

    });

    // Check if mark is followed by a line break and another mark
    document.querySelectorAll('mark + br + mark').forEach( (el, i) => {

        if ( el.offsetHeight < el.parentNode.offsetHeight ) {

            el.previousSibling.previousSibling.style.borderRadius = 0;

        }

    });

    // Trigger a FacetWP refresh if the submit button is clicked
    document.querySelectorAll('.wp-block-sowedia-filters__submit').forEach( (el, i) => {

        el.onclick = () => {
            FWP.refresh();
        }

    });

    // Handle post grid item height
    // document.querySelectorAll('.wp-block-sowmedia-post').forEach( (el, i) => {

    //     handlePostGridItemHeight( el );

    //     if ( window.innerWidth < 783 ) {
    //         return;
    //     }

    //     if ( el.classList.contains('is-style-vertical') && el.querySelector('.wp-block-sowmedia-post__thumbnail') ) {


    //         el.onmouseenter = () => {

    //             var excerpt = el.querySelector('.wp-block-sowmedia-post__excerpt');
    
    //             excerpt.querySelector('p').style.webkitLineClamp = 8;
                
    //             excerpt.style.height = excerpt.querySelector('p').offsetHeight + 'px';
    
    //         };
    
    //         el.onmouseleave = () => {
    
    //             var excerpt = el.querySelector('.wp-block-sowmedia-post__excerpt');
    
    //             excerpt.querySelector('p').style.webkitLineClamp = 3;
                
    //             excerpt.style.height = excerpt.querySelector('p').offsetHeight + 'px';
    
    //             excerpt.querySelector('p').style.webkitLineClamp = 8;
    
    
    //             setTimeout( () => {

    //                 if ( el !== document.querySelector('.wp-block-sowmedia-post:hover') ) {

    //                     excerpt.querySelector('p').style.webkitLineClamp = 3;

    //                 }
                        
    //             }, 500);
    
    //         };

    //     }

    // });

    // Loop trough Sowmedia filter blocks
    document.querySelectorAll('.wp-block-sowmedia-filters').forEach( (el, i) => {

        // Toggle the filter fields on click
        el.querySelector('.wp-block-sowmedia-filters__toggler').onclick = () => {

            el.querySelector('.wp-block-sowmedia-filters__fields').classList.toggle('is-opened');

            // Set the button label text based on filter fields visibility
            if ( el.querySelector('.wp-block-sowmedia-filters__fields').classList.contains('is-opened') ) {

                el.querySelector('.wp-block-sowmedia-filters__toggler').innerHTML = 'Filters verbergen';

            } else {

                el.querySelector('.wp-block-sowmedia-filters__toggler').innerHTML = 'Filter resultaten';

            }

        };

    });

    // Loop trough mega menu main links
    document.querySelectorAll('#masthead .main-navigation > ul > li.menu-item-has-children').forEach( (el, i) => {

        // If mouse enters the link, clear the sub-menu from active items
        el.querySelector('.menu-text').onmouseenter = () => {

            if ( el.querySelector('.is-active') ) {

                el.querySelector('.is-active').classList.remove('is-active');

            }

            // Make the first item active initially
            el.querySelector('.sub-menu .menu-item').classList.add('is-active');

        }

        if ( el.classList.contains('is-style-po') ) {

            el.querySelector('.sub-menu').innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="96" height="80" viewBox="0 0 96 80" fill="none"><g clip-path="url(#clip0_1609_16819)"><path d="M96 49.9373C96 39.9476 87.9394 31.8506 77.9945 31.8506C68.7533 31.8506 61.1406 38.8493 60.1112 47.8576C59.0818 38.8493 51.469 31.8506 42.2279 31.8506C32.283 31.8506 24.2224 39.9476 24.2224 49.9373C24.2224 49.9782 24.2224 50.0191 24.2224 50.06V80.0001H45.5196V59.7869C45.5196 59.4656 45.7813 59.2027 46.1011 59.2027C46.421 59.2027 46.6827 59.4656 46.6827 59.7869V80.0001H73.5397V59.7869C73.5397 59.4656 73.8014 59.2027 74.1212 59.2027C74.4411 59.2027 74.7028 59.4656 74.7028 59.7869V80.0001H96V50.06C96 50.0191 96 49.9782 96 49.9373Z" fill="url(#paint0_linear_1609_16819)"/><path d="M24.2225 0V32.0199H0C0 45.4564 10.8463 56.3517 24.2225 56.3517C37.5986 56.3517 48.4449 45.4564 48.4449 32.0199V0H24.2225Z" fill="#7AC3AE"/></g><defs><linearGradient id="paint0_linear_1609_16819" x1="24.2166" y1="55.9254" x2="96" y2="55.9254" gradientUnits="userSpaceOnUse"><stop stop-color="#3A6854"/><stop offset="1" stop-color="#519376"/></linearGradient><clipPath id="clip0_1609_16819"><rect width="96" height="80" fill="white"/></clipPath></defs></svg>';

        } else if ( el.classList.contains('is-style-vo') ) {

            el.querySelector('.sub-menu').innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="76" height="80" viewBox="0 0 76 80" fill="none"><path d="M22.7117 80H49.0151C49.0765 80 49.1212 80 49.1826 80C63.9961 80 75.9999 68.0589 75.9999 53.3352C75.9999 38.6115 63.9905 26.6704 49.1826 26.6704C49.1212 26.6704 49.0598 26.6704 48.9983 26.6704H22.7117V80Z" fill="url(#paint0_linear_1609_21113)"/><path d="M26.471 0C26.4095 0 26.3481 0 26.2867 0H0V26.0816H20.8852C21.2148 26.0816 21.4773 26.3427 21.4773 26.6704C21.4773 26.9981 21.2148 27.2591 20.8852 27.2591H0V53.3407H26.2867C26.3481 53.3407 26.4095 53.3407 26.471 53.3407C41.2845 53.3407 53.2883 41.3996 53.2883 26.6759C53.2883 11.9522 41.2845 0 26.471 0Z" fill="#458DB9"/><defs><linearGradient id="paint0_linear_1609_21113" x1="22.7117" y1="53.3352" x2="76.0055" y2="53.3352" gradientUnits="userSpaceOnUse"><stop stop-color="#003652"/><stop offset="1" stop-color="#004D75"/></linearGradient></defs></svg>';

        } else {

            el.querySelector('.sub-menu').innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" fill="none" preserveAspectRatio="none" viewBox="0 0 466 360">  <path fill="#FB7E73" d="M259.465 129.666c0 71.617-58.049 129.665-129.666 129.665C58.182 259.331.134 201.283.134 129.666.134 58.049 58.182 0 129.799 0c71.617 0 129.666 58.049 129.666 129.666Z"/>  <path fill="#FB7E73" d="M311.468 222.237c-4.431-38.599-37.203-68.581-76.978-68.581-42.812 0-77.526 34.715-77.526 77.526V360h91.641v-86.553a2.51 2.51 0 0 1 2.517-2.517 2.51 2.51 0 0 1 2.517 2.517V360h115.687v-86.608a2.51 2.51 0 0 1 2.516-2.517 2.51 2.51 0 0 1 2.517 2.517V360H466V231.182c0-42.811-34.714-77.526-77.525-77.526-39.803 0-72.575 29.982-77.007 68.581Z"/></svg>';

        }

        el.querySelector('.sub-menu').innerHTML += '<div class="sub-menu-background-shadow"></div>';

    });

    // Loop trough mega menu sub items
    document.querySelectorAll('#masthead .main-navigation > ul > li.menu-item-has-children > ul > li').forEach( (el, i) => {

        // If mouse enters the sub item, add the active state
        el.querySelector('.menu-text').onmouseenter = () => {

            var list = el.parentNode.parentNode;

            if ( list.querySelector('.is-active') ) {

                list.querySelector('.is-active').classList.remove('is-active');

            }

            el.classList.add('is-active');

        }

    });

    // Loop trough Sowmedia tabs blocks
    document.querySelectorAll('.wp-block-sowmedia-tabs').forEach( (el, i) => {

        // For all radio buttons
        el.querySelectorAll('.wp-block-sowmedia-tab__radio').forEach( (radio, j) => {

            // Set name attribute to make radio buttons work
            radio.setAttribute( 'name', 'tabs-' + i );

            // Click first radio button to open first tab
            if ( j == 0 ) {
                radio.click();
            }

        });

    });

    // Loop trough Sowmedia tab block labels
    document.querySelectorAll('.wp-block-sowmedia-tab__label').forEach( (el, i) => {

        // On label click handle the post grid item height
        el.onclick = () => {

            el.parentNode.querySelectorAll('.wp-block-sowmedia-post').forEach( (el2, i) => {

                handlePostGridItemHeight( el2, 25 );
        
            });

        };

    });

    // Loop trough hotspots in the Sowmedia image hotspot block
    document.querySelectorAll('[data-hotspot-content]').forEach( (el, i) => {

        // Add a tooltip on hover
        tippy( el, {
            content: el.getAttribute('data-hotspot-content'),
            theme: 'light'
        });

    });

    // On window resize
    window.onresize = () => {

        // Handle post grid item height on resize
        document.querySelectorAll('.wp-block-sowmedia-post').forEach( (el, i) => {

            handlePostGridItemHeight( el );
    
        });

    }

    // Loop trough file blocks and add ID to the file link
    document.querySelectorAll('.wp-block-file').forEach( (el, i) => {

        // Create a slug from the file name: lowercase-file-name.extension, keeping the extensions and . (dot) in the name
        var filename = el.querySelector('a').getAttribute('href').split('/').pop().toLowerCase().replace(/ /g,'-').replace(/[^\w-.]+/g,'');

        // Set download-{filename} as ID of the file link
        el.querySelectorAll('a').forEach( (el2, i) => {

            el2.setAttribute('id', 'download-' + filename);
 
        });

    });

    // Identify all anchors without an ID
    document.querySelectorAll('a:not([id])').forEach( (el, i) => {

        // Create a slug from the anchor text
        var slug = el.innerText.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');

        // Set link-{slug} as ID of the anchor
        el.setAttribute('id', 'link-' + slug);

    });

});

/*
 * Trigger each time FacetWP loads 
 *
 * This event triggers on init and when a facet value changes
 */
document.addEventListener('facetwp-refresh', function() {

    // Find posts in a FacetWP template
    document.querySelectorAll('.facetwp-template .wp-block-sowmedia-post').forEach( (el, i) => {

        // Handle the post grid item height
        handlePostGridItemHeight( el );

    });

    // Loop trough filters
    jQuery('.wp-block-sowmedia-filter').each(function() {
        
        var filter = jQuery(this);

        // If the filter doesn't already have a label
        if ( !filter.find('label').length ) {

            var facet = filter.find('.facetwp-facet');
            var facet_type = facet.attr('data-type');
            var filter_label = filter.attr('data-filter-label');

            // Do not add label to some facet types
            if (facet_type !== 'pager' && facet_type !== 'sort') {

                // Add label before the facet
                facet.before('<label>' + filter_label + '</label>');

            }

        }

    });

    // Loop trought facets on the page
    jQuery.each(FWP.settings.num_choices, function(key, val) {

        var facet = jQuery('.facetwp-facet-' + key);
        var filter = facet.closest('.wp-block-sowmedia-filter');

        // Toggle the filter based on if facet values are available
        if ( filter.length && !filter.hasClass('is-hidden') ) {
            (0 === val) ? filter.hide() : filter.show();
        }

    });

    // Preselect hidden filters, loop trough filters with filter value data attribute
    document.querySelectorAll('.wp-block-sowmedia-filter[data-filter-value]').forEach( (el, i) => {
        var facet_name = el.querySelector('.facetwp-facet').getAttribute('data-name');
        var values = el.getAttribute('data-filter-value').split(',');
        FWP.facets[facet_name] = values;
    });
});

document.addEventListener('facetwp-loaded', function() { // Runs after the refresh process, on each AJAX page load, and on the initial page load.
    // If FacetWP is loaded for the first time, preselect hidden filters.
    if ( ! FWP.loaded ) {
        // Preselect hidden filters, loop trough filters with filter value data attribute
        document.querySelectorAll('.wp-block-sowmedia-filter[data-filter-value]').forEach( (el, i) => {
            var facet_name = el.querySelector('.facetwp-facet').getAttribute('data-name');
            var values = el.getAttribute('data-filter-value').split(',');
            FWP.facets[facet_name] = values;
        });
    }
});

/*
 * Handle the grid item height for the wp-block-sowmeida-post-grid block
 */
function handlePostGridItemHeight( item, timeout = 0 ) {
    
    var image = item.querySelector('.wp-block-sowmedia-post__thumbnail > a');
    var content = item.querySelector('.wp-block-sowmedia-post__content');
    var excerpt = item.querySelector('.wp-block-sowmedia-post__excerpt');

    setTimeout( () => {

        // If the grid item is vertical and has an image
        if ( item.classList.contains('is-style-vertical') && image && image.offsetHeight ) {

            // Set the thumbnail height
            item.querySelector('.wp-block-sowmedia-post__thumbnail').style.height = image.offsetHeight + 'px';

            // If the grid item has an excerpt
            if ( excerpt ) {

                // Set the excerpt height
                excerpt.style.height = excerpt.querySelector('p').offsetHeight + 'px';

            }
            
            // Set the grid item min-height with a little delay
            setTimeout( () => {
                
                item.style.minHeight = ( image.offsetHeight + content.offsetHeight ) + 'px';

            }, 750);

        }

    }, timeout );
    
}